const translations = {
    placeholder: 'Terms',
    requiredError: 'This field is required'
};

export default translations;
